module.exports = __webpack_public_path__ + "img/the-other-queen.d499316f.png";